module.exports = __webpack_public_path__ + "static/assets/0875b05e2bf1a6a3eecce5943d7691a6.svg";